import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@totalsoft/rocket-ui';

function Header() {
  const { t } = useTranslation();
  return (
    <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
      {t('FinancialProduct.ListTitle')}
    </Typography>
  );
}

export default Header;
